import { initializeApp } from "https://www.gstatic.com/firebasejs/12.14.0/firebase-app.js";
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signOut,
} from "https://www.gstatic.com/firebasejs/12.14.0/firebase-auth.js";

const firebaseConfig = {
  apiKey: "AIzaSyC5pzRW922ZK7kjAiJQ1Dof__VwgDvEF3M",
  authDomain: "shadesofindia-f0c44.firebaseapp.com",
  projectId: "shadesofindia-f0c44",
  storageBucket: "shadesofindia-f0c44.firebasestorage.app",
  messagingSenderId: "842415442779",
  appId: "1:842415442779:web:f76f9f358d84e00953687e",
  measurementId: "G-71BMYGLPTG",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
let confirmationResult = null;
let recaptchaVerifier = null;
let countdown = null;
let verifiedEmail = null;
let seconds = 60;

function element(id) {
  return document.getElementById(id);
}

function showModal(title, message) {
  let modal = element("otpModal");

  if (!modal) {
    modal = document.createElement("div");
    modal.id = "otpModal";
    modal.innerHTML = `
      <div class="otp-modal-overlay">
        <div class="otp-modal" role="dialog" aria-modal="true" aria-labelledby="otpModalTitle">
          <h3 id="otpModalTitle"></h3>
          <p id="otpModalMessage"></p>
          <button type="button" id="otpModalClose">Close</button>
        </div>
      </div>`;
    document.body.appendChild(modal);

    const style = document.createElement("style");
    style.textContent = `
      .otp-modal-overlay { position:fixed; inset:0; background:rgba(0,0,0,.65); display:flex;
        align-items:center; justify-content:center; z-index:999999; }
      .otp-modal { width:90%; max-width:420px; background:#fff; padding:30px; text-align:center;
        border-radius:8px; }
      .otp-modal h3 { margin-bottom:10px; }
      .otp-modal button { width:100%; height:48px; border:0; background:#222; color:#fff;
        cursor:pointer; margin-top:20px; }`;
    document.head.appendChild(style);
    element("otpModalClose").addEventListener("click", () => {
      modal.style.display = "none";
    });
  }

  element("otpModalTitle").textContent = title;
  element("otpModalMessage").textContent = message;
  modal.style.display = "block";
}

function setButtonBusy(button, busy, busyText) {
  if (!button) return;
  if (busy) {
    button.dataset.originalText = button.textContent;
    button.textContent = busyText;
  } else {
    button.textContent = button.dataset.originalText || button.textContent;
  }
  button.disabled = busy;
}

function clearVerification() {
  verifiedEmail = null;
  element("otp_verified").value = "false";
  element("otp_verification_note")?.remove();
  element("otpSuccess").style.display = "none";
}

function normalizePhone() {
  const country = element("countryCode")?.value || "+91";
  const localNumber = element("mobile")?.value.replace(/\D/g, "") || "";
  if (localNumber.length < 6 || localNumber.length > 14) {
    throw new Error("Please enter a valid mobile number.");
  }
  return `${country}${localNumber}`;
}

async function createRecaptcha() {
  if (recaptchaVerifier) return recaptchaVerifier;
  recaptchaVerifier = new RecaptchaVerifier(auth, "sendOtp", { size: "invisible" });
  await recaptchaVerifier.render();
  return recaptchaVerifier;
}

function resetRecaptcha() {
  recaptchaVerifier?.clear();
  recaptchaVerifier = null;
}

function startTimer() {
  clearInterval(countdown);
  const timer = element("timer");
  const resend = element("resendOtp");
  seconds = 60;
  timer.style.display = "block";
  resend.style.display = "none";
  timer.textContent = `Resend OTP in ${seconds}s`;

  countdown = setInterval(() => {
    seconds -= 1;
    timer.textContent = `Resend OTP in ${seconds}s`;
    if (seconds <= 0) {
      clearInterval(countdown);
      timer.style.display = "none";
      resend.style.display = "block";
    }
  }, 1000);
}

async function sendOTP() {
  const button = element("sendOtp");
  try {
    const email = element("email")?.value.trim().toLowerCase();
    if (!email || !element("email").checkValidity()) {
      throw new Error("Please enter a valid email address before requesting an OTP.");
    }

    const phone = normalizePhone();
    clearVerification();
    setButtonBusy(button, true, "Sending...");
    const verifier = await createRecaptcha();
    confirmationResult = await signInWithPhoneNumber(auth, phone, verifier);
    element("otpMobileDisplay").textContent = phone;
    element("mobileWrapper").style.display = "none";
    element("otpWrapper").style.display = "block";
    element("verifyOtp").style.display = "block";
    element("otp").value = "";
    element("otp").focus();
    startTimer();
    showModal("OTP Sent", `A verification code was sent to ${phone}.`);
  } catch (error) {
    resetRecaptcha();
    showModal("OTP Failed", error?.message || "The OTP could not be sent. Please try again.");
  } finally {
    setButtonBusy(button, false);
  }
}

async function registerVerification(firebaseUser) {
  const email = element("email")?.value.trim().toLowerCase();
  if (!email) throw new Error("Enter your email address before verifying the OTP.");

  const idToken = await firebaseUser.getIdToken(true);
  const response = await fetch("/apps/phone-verification/verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, idToken }),
  });
  const result = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.error || "The server could not validate this phone number.");
  }

  let noteField = element("otp_verification_note");
  if (!noteField) {
    noteField = document.createElement("input");
    noteField.type = "hidden";
    noteField.id = "otp_verification_note";
    noteField.name = "customer[note]";
    element("create_customer").appendChild(noteField);
  }
  noteField.value = `OTP_VERIFIED:${result.verificationToken}`;

  // The browser must not directly set Shopify's customer phone field. The app
  // attaches the server-validated Firebase number in the customer webhook.
  element("customer_mobile")?.removeAttribute("name");
  element("otp_verified").value = "true";
  verifiedEmail = email;
  return result.phone;
}

async function verifyOTP() {
  const button = element("verifyOtp");
  try {
    const otp = element("otp")?.value.trim();
    if (!/^\d{6}$/.test(otp)) throw new Error("Please enter the six-digit OTP.");
    if (!confirmationResult) throw new Error("This OTP session expired. Request a new OTP.");

    setButtonBusy(button, true, "Verifying...");
    const result = await confirmationResult.confirm(otp);
    const verifiedPhone = await registerVerification(result.user);
    await signOut(auth);

    element("otpSuccess").style.display = "block";
    element("verifyOtp").style.display = "none";
    element("resendOtp").style.display = "none";
    element("timer").style.display = "none";
    clearInterval(countdown);
    showModal("Success", `${verifiedPhone} was securely verified.`);
  } catch (error) {
    clearVerification();
    showModal("Verification Failed", error?.message || "Invalid OTP. Please try again.");
  } finally {
    setButtonBusy(button, false);
  }
}

async function resendOTP() {
  resetRecaptcha();
  element("mobileWrapper").style.display = "block";
  element("otpWrapper").style.display = "none";
  await sendOTP();
}

function protectRegistrationForm() {
  const form = element("create_customer");
  if (!form) return;

  element("email")?.addEventListener("input", () => {
    const currentEmail = element("email").value.trim().toLowerCase();
    if (verifiedEmail && currentEmail !== verifiedEmail) clearVerification();
  });

  form.addEventListener("submit", (event) => {
    const email = element("email")?.value.trim().toLowerCase();
    if (element("otp_verified")?.value !== "true" || email !== verifiedEmail) {
      event.preventDefault();
      showModal("Verification Required", "Please verify your mobile number for this email address.");
      return;
    }
    if (!element("termsCheckbox")?.checked) {
      event.preventDefault();
      showModal("Terms Required", "Please accept the Terms & Conditions and Privacy Policy.");
    }
  });
}

document.addEventListener("DOMContentLoaded", async () => {
  if (!element("sendOtp")) return;
  element("customer_mobile")?.removeAttribute("name");
  element("sendOtp").addEventListener("click", sendOTP);
  element("verifyOtp").addEventListener("click", verifyOTP);
  element("resendOtp").addEventListener("click", resendOTP);
  protectRegistrationForm();

  try {
    await createRecaptcha();
  } catch {
    resetRecaptcha();
  }
});
